/* eslint-disable react/require-default-props */
import React, { ReactNode } from 'react';
import ExternalLink from 'components/atoms/external-link';
import { CommonOrganismProps } from '../../types';

interface Props extends CommonOrganismProps {
  icon?: string;
  iconElement?: ReactNode;
  iconHeader?: string | ReactNode;
  iconFooter?: string | ReactNode;
  iconStyles?: HTMLDivElement['className'];
  iconLink?: string;
  alt?: string;
  children: ReactNode;
}

export default function SectionWithLeftIcon({
  icon,
  iconElement,
  iconHeader,
  iconFooter,
  iconStyles,
  iconLink,
  alt,
  title,
  styles,
  children,
}: Props) {
  return (
    <div
      className={`flex flex-col md:flex-row items-center justify-start p-4 rounded-xl text-start px-4 sm:px-8 w-full gap-2 md:gap-5 ${styles}`}
      style={{ backgroundColor: 'rgb(275,275,275,0.03)' }}>
      <div className="flex flex-col justify-center items-center text-center gap-2">
        {iconHeader && <div className="text-md">{iconHeader}</div>}
        {iconElement ?? <img src={icon} alt={alt} className={`h-16 w-16 ${iconStyles}`} />}
        {iconFooter && (
          <div className="flex items-center gap-1">
            <div className="text-md">{iconFooter}</div>
            {iconLink && <ExternalLink href={iconLink} />}
          </div>
        )}
      </div>
      <div className="h-full w-full flex flex-1 flex-col justify-start items-center md:items-start">
        {title}
        <div className="w-full">{children}</div>
      </div>
    </div>
  );
}
